import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=eb93cbe0&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=eb93cbe0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb93cbe0",
  null
  
)

export default component.exports